import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://c2bsterlingecommerce.azurewebsites.net/api/'
});

instance.interceptors.request.use(
  async (config) => {
    config.headers['Content-Type'] ='application/json';
    const userToken = localStorage.getItem('LV-Auth')
    if (userToken) {
      config.headers.Authorization = `Bearer ${userToken}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err)
  }
)

export default instance;
